import React from 'react';
function MailBox({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M3.65 17.35h8.7V12a4.35 4.35 0 00-8.7 0v5.35z" clipRule="evenodd" />
      <path strokeLinecap="square" d="M12.5 17.35h8M8.5 7.65h7" />
      <path d="M16 7.65c2.64.044 4.534 1.87 4.534 4.638V18" />
      <path strokeLinecap="square" d="M15.5 11.5v-8" />
      <path strokeLinejoin="round" d="M20.5 2.5h-5v3h5v-3zM15 17.35h-3V21h3v-3.65z" />
    </svg>
  );
}

export default MailBox;
